import { hasPermission } from '../components/auth/authUtils';
import permissionTypes from '../constants/permissionTypes';
import { User } from '../types/user';

type CanCopyRequestProps = {
  companyId: string;
  requestedById: string;
  currentUser: User;
};

export function canCopyRequest({
  companyId,
  requestedById,
  currentUser,
}: CanCopyRequestProps) {
  if (!companyId || !requestedById || !currentUser) {
    return false;
  }
  return (
    companyId === currentUser.companyId ||
    hasPermission(currentUser, permissionTypes.REQUEST_ON_BEHALF_OF)
  );
}
